// Custom MIME type for element drags. Deliberately NOT text/plain: Froala's
// clipboard module intercepts drops carrying text/html or text/plain on any
// mounted instance (active cell / active text element) and pastes the raw
// payload as text before the app-level drop handler runs.
export const ELEMENT_DRAG_MIME = "application/x-storydoc-element";

export const DRAG_CONSTANTS = {
  // REPLACE_THRESHOLD_UPPER: 65,
  // REPLACE_THRESHOLD_LOWER: 35,
  DEFAULT_INDICATOR_HEIGHT: 2,
  SLIDE_SELECTOR: '#content-sgKecQsAYKy7MX4 [data-layer-type="slide"]',
  COMBOS_SELECTOR: '[data-layer-type="combos"]',
  ITEM_SELECTOR:
    '[data-layer-type="element"], .add-entity-placeholder-SxqseNspfN3v066',
  COMBO_SELECTOR: '[data-layer-type="combo"]',
  // Editor-only cell node: `data-cell-id` is set on every `<td>` in table-cell.tsx.
  CELL_SELECTOR: "[data-cell-id]",
  INVERT_COLOR_ELEMENTS: [
    "RichText",
    "CollapsibleText",
    "AnimatedNumbers",
    "Chart",
    "Icon",
  ],
} as const;
